import type { Components } from './index'

export const components: Components = {
  ListRowActions: () => null,
}
